import { useCallback, useState } from 'preact/hooks';

/**
 *
 * @param startingGoalAmount
 * @param startingCurrentAmount
 * @returns {{updateAmounts: ((function({newCurrentAmount: number, newGoalAmount: number}): void)|*), currentAmount: number, setCurrentAmount: (value: (((prevState: number) => number) | number)) => void, setGoalAmount: (value: (((prevState: number) => number) | number)) => void, goalAmount: number}}
 */
export default function useAdjustableAmounts(
  { startingGoalAmount = 1000, startingCurrentAmount = 750 } = {
    startingCurrentAmount: 750,
    startingGoalAmount: 1000,
  }
) {
  const [currentAmount, setCurrentAmount] = useState(startingCurrentAmount);
  const [goalAmount, setGoalAmount] = useState(startingGoalAmount);

  const updateAmounts = useCallback(({ newCurrentAmount, newGoalAmount }) => {
    if (
      newGoalAmount !== undefined &&
      newGoalAmount !== null &&
      !isNaN(newGoalAmount)
    ) {
      setGoalAmount(newGoalAmount);
    }

    if (
      newCurrentAmount !== undefined &&
      newCurrentAmount !== null &&
      !isNaN(newCurrentAmount)
    ) {
      setCurrentAmount(newCurrentAmount);
    }
  }, []);

  return {
    updateAmounts,
    currentAmount,
    setCurrentAmount,
    setGoalAmount,
    goalAmount,
  };
}
